import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { Task } from "@dtm-frontend/search-and-help-shared-lib/incident";
import { EmptyStateMode } from "@dtm-frontend/shared/ui";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";

interface TaskListComponentState {
    tasks: Task[];
}

@Component({
    selector: "sah-mobile-lib-task-list[tasks]",
    templateUrl: "task-list.component.html",
    styleUrls: ["task-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class TaskListComponent {
    @Input() public set tasks(value: Task[] | undefined) {
        this.localStore.patchState({ tasks: value ?? [] });
    }

    @Output() protected readonly taskPreview = new EventEmitter<Task>();

    protected readonly EmptyStateMode = EmptyStateMode;

    protected readonly tasks$ = this.localStore.selectByKey("tasks");

    constructor(private readonly localStore: LocalComponentStore<TaskListComponentState>) {
        this.localStore.setState({
            tasks: [],
        });
    }
}
